import React from "react"
import Section from "../../../core/layout/main/section/Section"
import Card from "../../common/blocks/card/Card"
import * as classNames from "./RhCtxAgencyPresentationSection.module.scss"
import Image from "../../common/blocks/image/Image"

function RhCtxAgencyPresentationSection({ title, text, image, cardTitle }) {
  console.log("RhCtxAgencyPresentationSection", image)
  return (
    <Section
      className={`${classNames.image} pbl-6 mt-10`}
      container=" xlarge"
    >
      <div className={`${classNames.CardTitle} text-center pin-6 pb-3`}>
        <h2 className="mb-2">{title}</h2>
        <p className="mb-2">{text}</p>
      </div>
      <div className="relative flex justify-content-center align-items-center">
        <Image 
          className={classNames.image}
          dataSizesPreset="gd"
          imgSrc={image?.data?.attributes?.url}
          imgAlt=""
          imgWidth=""
          imgHeight=""
          formats={image?.data?.attributes?.formats}
        />
        <Card className={`pin-6 pbl-6 ${classNames.card} `}>
          <p className="fs-20">{cardTitle}</p>
        </Card>
      </div>
    </Section>
  )
}

export const name = "RhCtxAgencyPresentation"

export const init = (componentData, pageContext) => {
  const lastJobAds = pageContext.itemData
  return (
    <RhCtxAgencyPresentationSection
      key={componentData.id}
      title={lastJobAds?.attributes?.presentationTitle}
      text={lastJobAds?.attributes?.presentationText}
      image={lastJobAds?.attributes?.presentationImage}
      cardTitle={lastJobAds?.attributes?.presentationExergue}
    />
  )
}

export default RhCtxAgencyPresentationSection
